"use client";
import React from "react";
import { m } from "motion/react";
import { IconBrandInstagram, IconChevronRight } from "@tabler/icons-react";
import Link from "next/link";
import Image from "next/image";

const posts = [
    {
        id: 1,
        image: "/instagram/1.jpg",
        type: "Estratégia",
        title: "Boas ideias merecem mais que sorte.",
        link: "https://www.instagram.com/p/DOMH7R1j3tC/"
    },
    {
        id: 2,
        image: "/instagram/2.jpg",
        type: "Performance",
        title: "Pode ser que hoje você esteja perdendo vendas e nem saiba...",
        link: "https://www.instagram.com/p/DO6L3WpjXcf/"
    },
    {
        id: 3,
        image: "/instagram/0.jpg",
        type: "Tendência",
        title: "Em 2026, cada anúncio vai custar mais caro do que você imagina…",
        link: "https://www.instagram.com/p/DOMH7R1j3tC/"
    },
];

export default function InstagramSection() {
    return (
        <section className="py-24 bg-neutral-950 relative overflow-hidden">
            {/* Background Accent */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-midas-yellow-500/5 rounded-full blur-[120px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-8">
                    <div className="max-w-2xl">
                        <div className="flex items-center gap-2 text-midas-yellow-500 mb-4">
                            <IconBrandInstagram className="w-6 h-6" />
                            <span className="font-bold tracking-widest uppercase text-sm">Nossa Garagem</span>
                        </div>
                        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tighter">
                            Acompanhe a <span className="text-midas-yellow-500">Estratégia</span> em Tempo Real.
                        </h2>
                        <p className="text-neutral-400 text-lg md:text-xl leading-relaxed">
                            No Instagram, mostramos o que as outras agências escondem: os bastidores da execução de alta performance e os ajustes que geram ROI.
                        </p>
                    </div>

                    <Link
                        href="https://instagram.com/midasads"
                        target="_blank"
                        className="group flex items-center gap-2 px-8 py-4 bg-white/5 hover:bg-midas-yellow-500 hover:text-black transition-all rounded-full border border-white/10 font-bold"
                    >
                        @midasads
                        <IconChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {posts.map((post, idx) => (
                        <m.div
                            key={post.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                            viewport={{ once: true }}
                            className="group relative aspect-square rounded-3xl overflow-hidden border border-white/5 bg-neutral-900"
                        >
                            <Link href={post.link} target="_blank" className="block w-full h-full relative cursor-pointer z-20">

                                <Image
                                    src={post.image}
                                    alt={post.title}
                                    fill
                                    sizes="(max-width: 768px) 100vw, 33vw"
                                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                                />

                                {/* Glassmorphism Overlay */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-60 transition-opacity group-hover:opacity-80" />

                                <div className="absolute inset-x-0 bottom-0 p-8 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                                    <span className="px-3 py-1 bg-midas-yellow-500 text-black text-[10px] font-black uppercase tracking-widest rounded-full mb-3 inline-block">
                                        {post.type}
                                    </span>
                                    <h3 className="text-2xl font-bold text-white mb-2 leading-none">
                                        {post.title}
                                    </h3>
                                    <p className="text-white/60 text-sm font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                        Ver post no Instagram <IconChevronRight className="w-4 h-4" />
                                    </p>
                                </div>
                            </Link>
                        </m.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
